import { useContext } from 'react';

import { CartController } from './types';
import { CartControllerContext } from './CartControllerContext';

export const useCartController = (): CartController => {
  return useContext(CartControllerContext);
};
